interface NACIconProps {
  className?: string;
}

export const NACIcon = ({ className = "h-4 w-4" }: NACIconProps) => {
  return (
    <img 
      src="/NAC_Icon_Only.png" 
      alt="NAC Logo" 
      className={className}
    />
  );
};
